import { Immutable } from "immer";
import React from "react";
import { FinancingModalTrigger } from "tsi-common-react/src/apps/financing/FinancingModalTrigger";
import { t } from "ttag";

type IProps = Immutable<{
    classString: string;
}>;

export const FinancingModalTriggerCheckNow = (
    props: IProps,
): React.JSX.Element => {
    return (
        <span>
            <FinancingModalTrigger
                modalType="prequal-app"
                className={props.classString}
            >
                {t`Check Now`}
            </FinancingModalTrigger>
        </span>
    );
};
